<div class="customModal" (click)="closeModal($event)" [ngStyle]="{'padding': paddingModal()}">
  <div class="modal-content" [ngStyle]="{'background': background(), 'width': width(), 'height': height(), 'overflow': overflow(), 'gap': gap()}">
    <div class="modal-content__header"
    [ngStyle]="{'background': headerBackground(), 'color': headerColor(), 'padding' : paddingHeader()}">

    <div class="header-inner">
      <div class="modal-content__header__left">
        @if(iconBack()){
          <i class="icon icon-arrow-back-1" (click)="backClicked()"></i>
        }
        <h1>{{title()}}
          @if(searchResult()){
            <span [ngStyle]="{color: searchResult().color}">"{{searchResult().text}}"</span>
          }
        </h1>
      </div>

      <div class="modal-content__header__right">
        <div class="modal-content__header__link" (click)="linkClicked()">
          {{link()}}
        </div>
        <div class="modal-content__header__icon" (click)="dialogClose()">
          <i class="icon icon-close"></i>
        </div>
      </div>
    </div>

  </div>

    <div class="modal-content__detail" [ngStyle]="{'padding': paddingContent()}">
      <ng-content></ng-content>
    </div>
    @if(haveFooter()){
      <div class="modal-footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    }
  </div>
</div>
